import React, { useEffect, useState } from "react";
import API from "../api";
import { Carousel, Container, Row, Col, Card, Spinner, Button } from "react-bootstrap";
import { FaInstagram, FaTiktok, FaArrowUp, FaFacebook } from "react-icons/fa";
import "../styles/home.css";
import Logo from "../assets/logo-paud.png";
import { Link } from "react-router-dom";

export default function Home() {
  const [data, setData] = useState([]);
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showTopBtn, setShowTopBtn] = useState(false);

  const load = async () => {
    try {
      setLoading(true);
      const [resContent, resNews] = await Promise.all([
        API.get("/content"),
        API.get("/news"),
      ]);
      setData(resContent.data || []);
      setNews(resNews.data || []);
    } catch (err) {
      console.error("Error load home:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();

    const handleScroll = () => {
      setShowTopBtn(window.scrollY > 300);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const banners = data.filter((d) => d.type === "banner");
  const visiItems = data.filter((d) => d.type === "visi");
  const misiItems = data.filter((d) => d.type === "misi");
  const tentang = data.find((d) => d.type === "tentang");
  const programs = data.filter((d) => d.type === "program");
  const IMAGE_URL = process.env.REACT_APP_UPLOAD_URL || "";
  if (loading) {
    return (
      <div className="text-center mt-5">
        <Spinner animation="border" />
        <p>Loading website...</p>
      </div>
    );
  }
  return (
    <div className="home-wrapper">
      {/* Top follow bar */}
      <div className="bg-primary text-white py-1 top-bar">
        <Container className="d-flex justify-content-between align-items-center flex-wrap">
          <div><strong>Follow us:</strong></div>
          <div className="d-flex gap-3">
            <span>TikTok:</span>
            <a href="https://www.tiktok.com/@paud.kb.cahaya.pi" className="text-white"><FaTiktok /></a>
            <span>Instagram:</span>
            <a href="https://www.instagram.com/paudkb_cahayapiraditakaning" className="text-white"><FaInstagram /></a>
            <span>Facebook:</span>
            <a href="https://www.facebook.com/share/18gM9NeyiF/" className="text-white"><FaFacebook /></a>
          </div>
        </Container>
      </div>

      {/* Banner */}
      {banners.length > 0 && (
        <Carousel fade interval={4000} className="home-carousel">
          {banners.map((b) => (
            <Carousel.Item key={b.id}>
              <img
                className="d-block w-100 banner-img"
                src={b.image ? `${IMAGE_URL}/uploads/${b.image}` : "/default-banner.jpg"}
                alt={b.title || "banner"}
                style={{ height: "600px", objectFit: "cover" }}
              />
              <Carousel.Caption className="text-start" style={{ left: "20px", right: "20px" }}>
                <h2>{b.title}</h2>
                <p>{b.description}</p>
              </Carousel.Caption>
            </Carousel.Item>
          ))}
        </Carousel>
      )}

      {/* About */}
      <Container className="about mt-5">
        <div className="d-flex align-items-center mb-3">
          <img src={Logo} alt="Logo Institusi" style={{ width: "60px", height: "60px", objectFit: "contain", marginRight: "12px" }}/>
          <h2 className="text-start m-0">Tentang Kami</h2>
        </div>
        <p className="text-start text-justify">
          {tentang?.description || "Selamat datang di PAUD kami yang berfokus pada pendidikan anak usia dini."}
        </p>

        <Row className="mt-4">
          <Col xs={12} md={6} className="mb-3">
            <div className="card-visi p-4 hover-card text-start">
              <h3>🌟 Visi</h3>
              {visiItems.length === 0 ? <p>Belum ada data visi</p> : visiItems.map((v) => <p key={v.id}>{v.description}</p>)}
            </div>
          </Col>
          <Col xs={12} md={6}>
            <div className="card-misi p-4 hover-card text-start">
              <h3>🎯 Misi</h3>
              {misiItems.length === 0 ? <p>Belum ada data misi</p> : misiItems.map((m) => <p key={m.id}>{m.description}</p>)}
            </div>
          </Col>
        </Row>
      </Container>

      {/* Program */}
      <div className="program-section mt-5 py-5">
        <Container>
          <h2 className="text-center mb-4 program-title">📚 Program</h2>
          {programs.length === 0 ? (
            <p className="text-center text-muted">Program belum tersedia</p>
          ) : (
            <Row>
              {programs.map((p) => (
                <Col xs={12} sm={6} md={4} key={p.id} className="mb-3">
                  <Card className="hover-card h-100 program-card">
                    <Card.Body className="text-start">
                      <Card.Title>{p.title}</Card.Title>
                      <Card.Text>{p.description}</Card.Text>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>
          )}
        </Container>
      </div>

      {/* News Section */}
      <div className="news-section mt-5 py-5" style={{ background: "linear-gradient(135deg, #f8f9fa, #e9ecef)" }}>
        <Container>
          <h2 className="text-center mb-4">📰 Berita</h2>
          {news.length === 0 ? (
            <p className="text-center text-muted">Belum ada berita terbaru</p>
          ) : (
            <Row>
              {news.map((n, index) => {
                const gradients = [
                  "linear-gradient(145deg, #ffecd2, #fcb69f)",
                  "linear-gradient(145deg, #d4fc79, #96e6a1)",
                  "linear-gradient(145deg, #a1c4fd, #c2e9fb)",
                  "linear-gradient(145deg, #fbc2eb, #a6c1ee)",
                  "linear-gradient(145deg, #fdfbfb, #ebedee)",
                ];
                const bgGradient = gradients[index % gradients.length];

                return (
                  <Col xs={12} sm={6} md={4} key={n.id} className="mb-3">
                    <div
                      style={{
                        background: bgGradient,
                        borderRadius: "12px",
                        padding: "0.5rem",
                        height: "100%",
                        boxShadow: "0 4px 8px rgba(0,0,0,0.05)",
                        transition: "transform 0.2s",
                      }}
                      className="hover-card"
                    >
                      <Link
                        to={`/news/${n.id}`}
                        style={{ textDecoration: "none", color: "inherit" }}
                      >
                        {n.image && (
                          <img
                            src={`${IMAGE_URL}/uploads/${n.image}`}
                            alt={n.title}
                            style={{
                              width: "100%",
                              borderRadius: "10px",
                              objectFit: "cover",
                              marginBottom: "10px",
                              height: "180px",
                            }}
                          />
                        )}
                        <div style={{ padding: "0 0.5rem 0.5rem 0.5rem" }}>
                          <h5>{n.title}</h5>
                          <p className="text-justify" style={{ fontSize: "0.9rem" }}>
                            {n.content.length > 80
                              ? n.content.substring(0, 80) + "..."
                              : n.content}
                          </p>
                        </div>
                      </Link>
                    </div>
                  </Col>
                );
              })}
            </Row>
          )}
        </Container>
      </div>

      <div className="news-section mt-5 py-5" style={{ background: "linear-gradient(135deg, #f8f9fa, #e9ecef)" }}>

        {/* ================= CONTACT (DARI CODE KAMU) ================= */}
        <Container className="mt-5 mb-5" id="contact">
          <h2 className="text-center mb-4">📞 Kontak Kami</h2>

          <Row className="g-4">

            <Col md={6}>
              <Card className="p-4">
                <h4>Informasi Kontak</h4>
                <p>📍 Gg. Nangka RT. 001 RW. 002 Karang Asem Timur, Kec. Citeureup, Kabupaten Bogor, Jawa Barat</p>
                <p>📞 021 8908 5323</p>
                <p>📞 +62 857 7779 9560</p>

                <div className="d-flex gap-3 mt-3">
                  <p><strong>Tiktok:</strong></p>
                  <a href="https://www.tiktok.com/@paud.kb.cahaya.pi" target="_blank" rel="noopener noreferrer">
                    <FaTiktok size={28} />
                  </a>
                  <p><strong>Istagram:</strong></p>
                  <a href="https://www.instagram.com/paudkb_cahayapiraditakaning" target="_blank" rel="noopener noreferrer">
                    <FaInstagram size={28} />
                  </a>
                  <p><strong>Facebook:</strong></p>
                  <a href="https://www.facebook.com/share/18gM9NeyiF/" target="_blank" rel="noopener noreferrer">
                    <FaFacebook size={28} />
                  </a>                  
                </div>

                <Button
                    href="https://wa.me/6285777799560"
                    target="_blank"
                    rel="noopener noreferrer"
                    variant="success"
                    className="mt-4"
                    style={{ borderRadius: "50px", padding: "0.5rem 2rem" }}
                  >
                    Hubungi via WhatsApp
                </Button>
              </Card>
            </Col>

            <Col md={6}>
              <iframe
                title="map"
                src="https://maps.google.com/maps?q=PAUD%20KB%20Cahaya%20Piradita%20Kaning&t=&z=15&ie=UTF8&iwloc=&output=embed"
                width="100%"
                height="300"
                style={{ border: 0 }}
              />
            </Col>
          </Row>
        </Container>      
      </div>

      {/* Back to Top Button */}
      <Button
        onClick={scrollToTop}
        style={{
          position: "fixed",
          bottom: "30px",
          right: "30px",
          borderRadius: "50%",
          padding: "0.6rem 0.6rem",
          zIndex: 1000,
          boxShadow: "0 4px 6px rgba(0,0,0,0.2)",
          opacity: showTopBtn ? 1 : 0,
          visibility: showTopBtn ? "visible" : "hidden",
          transition: "opacity 0.4s ease, visibility 0.4s ease",
        }}
      >
        <FaArrowUp />
      </Button>
    </div>
  );
}